// import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
// import api from '@/services/axios';
//
// /* =========================
//    Helpers localStorage
// ========================= */
//
// const persistAuth = (token, user) => {
//     if (token) localStorage.setItem('token', token);
//     if (user) localStorage.setItem('user', JSON.stringify(user));
// };
//
// const clearPersistedAuth = () => {
//     localStorage.removeItem('token');
//     localStorage.removeItem('user');
// };
//
// /* =========================
//    Thunks
// ========================= */
//
// export const login = createAsyncThunk(
//     'auth/login',
//     async ({ email, password }, { rejectWithValue }) => {
//         try {
//             const { data } = await api.post('/login_verify', { email, password });
//
//             if (!data.success) {
//                 return rejectWithValue(data.error || 'Login failed');
//             }
//
//             persistAuth(data.token, data.user);
//             return data;
//
//         } catch (error) {
//             return rejectWithValue(
//                 error.response?.data?.error ||
//                 error.message ||
//                 'Login error'
//             );
//         }
//     }
// );
//
// export const logout = createAsyncThunk(
//     'auth/logout',
//     async () => {
//         // JWT stateless → pas besoin d’API
//         clearPersistedAuth();
//     }
// );
//
// /* =========================
//    Initial State
// ========================= */
//
// const initialState = {
//     user: null,
//     token: null,
//     isAuthenticated: false,
//     isLoading: false,
//     error: null,
//     hasCheckedAuth: false,
// };
//
// /* =========================
//    Slice
// ========================= */
//
// const authSlice = createSlice({
//     name: 'auth',
//     initialState,
//
//     reducers: {
//         syncAuthState: (state) => {
//             const token = localStorage.getItem('token');
//             const userStr = localStorage.getItem('user');
//
//             state.token = token;
//             state.isAuthenticated = !!token;
//             state.hasCheckedAuth = true;
//
//             if (userStr) {
//                 try {
//                     state.user = JSON.parse(userStr);
//                 } catch {
//                     state.user = null;
//                     localStorage.removeItem('user');
//                 }
//             }
//         },
//
//         clearError: (state) => {
//             state.error = null;
//         }
//     },
//
//     extraReducers: (builder) => {
//         builder
//             /* ===== LOGIN ===== */
//             .addCase(login.pending, (state) => {
//                 state.isLoading = true;
//                 state.error = null;
//             })
//             .addCase(login.fulfilled, (state, action) => {
//                 state.isLoading = false;
//                 state.isAuthenticated = true;
//                 state.token = action.payload.token;
//                 state.user = action.payload.user;
//                 state.error = null;
//                 state.hasCheckedAuth = true;
//             })
//             .addCase(login.rejected, (state, action) => {
//                 state.isLoading = false;
//                 state.isAuthenticated = false;
//                 state.token = null;
//                 state.user = null;
//                 state.error = action.payload;
//                 state.hasCheckedAuth = true;
//             })
//
//             /* ===== LOGOUT ===== */
//             .addCase(logout.fulfilled, (state) => {
//                 state.isAuthenticated = false;
//                 state.token = null;
//                 state.user = null;
//                 state.error = null;
//                 state.hasCheckedAuth = true;
//             });
//     }
// });
//
// /* =========================
//    Exports
// ========================= */
//
// export const { syncAuthState, clearError } = authSlice.actions;
//
// export const selectAuth = (state) => state.auth;
// export const selectUser = (state) => state.auth.user;
// export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;
// export const selectIsLoading = (state) => state.auth.isLoading;
// export const selectError = (state) => state.auth.error;
// export const selectHasCheckedAuth = (state) => state.auth.hasCheckedAuth;
//
// export default authSlice.reducer;
// store/slices/authSlice.js
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import api from '@/services/axios';
import TokenService from '@/services/TokenService'; // Ajoutez cette importation

/* =========================
   Helpers localStorage
========================= */

const persistAuth = (token, user, rememberMe = false) => {
    if (rememberMe) {
        if (token) localStorage.setItem('token', token);
        if (user) localStorage.setItem('user', JSON.stringify(user));
    } else {
        if (token) sessionStorage.setItem('token', token);
        if (user) sessionStorage.setItem('user', JSON.stringify(user));
    }
};

const clearPersistedAuth = () => {
    TokenService.clearAllAuthData();
};

/* =========================
   Thunks
========================= */

export const login = createAsyncThunk(
    'auth/login',
    async ({ email, password, rememberMe = false }, { rejectWithValue }) => {
        try {
            const { data } = await api.post('/login_verify', { email, password });

            if (!data.success) {
                return rejectWithValue(data.error || 'Login failed');
            }

            persistAuth(data.token, data.user, rememberMe);
            TokenService.setToken(data.token, rememberMe);

            return {
                token: data.token,
                user: data.user,
                rememberMe
            };

        } catch (error) {
            return rejectWithValue(
                error.response?.data?.error ||
                error.message ||
                'Login error'
            );
        }
    }
);

export const logout = createAsyncThunk(
    'auth/logout',
    async (_, { dispatch }) => {
        try {
            // Optionnel: Appeler l'API de logout si nécessaire
            // await api.post('/logout');
        } catch (error) {
            console.error('Logout API error:', error);
        } finally {
            clearPersistedAuth();
            dispatch(checkTokenExpired()); // Ajouter un état d'expiration
        }
    }
);

export const checkTokenExpired = createAsyncThunk(
    'auth/checkTokenExpired',
    async () => {
        clearPersistedAuth();
        return { expired: true };
    }
);

/* =========================
   Initial State
========================= */

const initialState = {
    user: null,
    token: null,
    isAuthenticated: false,
    isLoading: false,
    error: null,
    hasCheckedAuth: false,
    tokenExpired: false, // Nouveau champ
    lastCheck: null,
};

/* =========================
   Slice
========================= */

const authSlice = createSlice({
    name: 'auth',
    initialState,

    reducers: {
        syncAuthState: (state) => {
            // Utiliser TokenService pour une gestion cohérente
            const token = TokenService.getToken();
            const userStr = localStorage.getItem('user') || sessionStorage.getItem('user');

            state.token = token;
            state.isAuthenticated = TokenService.isAuthenticated();
            state.hasCheckedAuth = true;
            state.tokenExpired = false;
            state.lastCheck = Date.now();

            if (userStr) {
                try {
                    state.user = JSON.parse(userStr);
                } catch {
                    state.user = null;
                    localStorage.removeItem('user');
                    sessionStorage.removeItem('user');
                }
            }

            // Si token invalide, nettoyer
            if (token && !TokenService.isValidToken(token)) {
                clearPersistedAuth();
                state.isAuthenticated = false;
                state.token = null;
                state.user = null;
                state.tokenExpired = true;
            }
        },

        clearError: (state) => {
            state.error = null;
        },

        tokenExpired: (state) => {
            clearPersistedAuth();
            state.isAuthenticated = false;
            state.token = null;
            state.user = null;
            state.tokenExpired = true;
        },

        validateToken: (state) => {
            const token = TokenService.getToken();
            state.isAuthenticated = TokenService.isAuthenticated();
            state.tokenExpired = !TokenService.isAuthenticated();
            state.lastCheck = Date.now();

            if (!state.isAuthenticated) {
                state.token = null;
                state.user = null;
            }
        }
    },

    extraReducers: (builder) => {
        builder
            /* ===== LOGIN ===== */
            .addCase(login.pending, (state) => {
                state.isLoading = true;
                state.error = null;
                state.tokenExpired = false;
            })
            .addCase(login.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isAuthenticated = true;
                state.token = action.payload.token;
                state.user = action.payload.user;
                state.error = null;
                state.hasCheckedAuth = true;
                state.tokenExpired = false;
                state.lastCheck = Date.now();
            })
            .addCase(login.rejected, (state, action) => {
                state.isLoading = false;
                state.isAuthenticated = false;
                state.token = null;
                state.user = null;
                state.error = action.payload;
                state.hasCheckedAuth = true;
                state.tokenExpired = false;
            })

            /* ===== LOGOUT ===== */
            .addCase(logout.fulfilled, (state) => {
                state.isAuthenticated = false;
                state.token = null;
                state.user = null;
                state.error = null;
                state.hasCheckedAuth = true;
                state.tokenExpired = false;
            })

            /* ===== TOKEN EXPIRED ===== */
            .addCase(checkTokenExpired.fulfilled, (state) => {
                state.isAuthenticated = false;
                state.token = null;
                state.user = null;
                state.tokenExpired = true;
                state.lastCheck = Date.now();
            });
    }
});

/* =========================
   Exports
========================= */

export const {
    syncAuthState,
    clearError,
    tokenExpired,
    validateToken
} = authSlice.actions;

export const selectAuth = (state) => state.auth;
export const selectUser = (state) => state.auth.user;
export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;
export const selectIsLoading = (state) => state.auth.isLoading;
export const selectError = (state) => state.auth.error;
export const selectHasCheckedAuth = (state) => state.auth.hasCheckedAuth;
export const selectTokenExpired = (state) => state.auth.tokenExpired;

export default authSlice.reducer;
